import { Component } from '@/types'
import { showCartCommentModal } from './cart-comment-modal'

const component: Component = ref => {
  if (!ref.cartCommentButton) return

  async function updateButtonText() {
    try {
      // Fetch current cart to check if note exists
      const response = await fetch('/cart.js')
      const cart = await response.json()

      const hasComment = cart.note && cart.note.trim() !== ''

      // Update all button instances
      ref.cartCommentButton.forEach((button: HTMLElement) => {
        const addText = button.dataset.addText || 'Add comment'
        const editText = button.dataset.editText || 'Edit my comment'

        button.textContent = hasComment ? editText : addText
      })
    } catch (error) {
      console.error('Error updating cart comment button:', error)
    }
  }

  // Initialize button text
  updateButtonText()

  // Open modal when button is clicked
  ref.cartCommentButton.forEach((button: HTMLElement) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      showCartCommentModal()
    })
  })

  // Update button text when comment is saved
  window.addEventListener('se-event.cart.comment-updated', updateButtonText)

  // Update button text when cart is updated (in case note changed elsewhere)
  window.addEventListener('se-event.cart.updated', updateButtonText)
}

export default component
